import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`As console logs can contain sensitive information, we do not capture these logs automatically. You can enable this feature globally `}<em parentName="p">{`either`}</em>{` from your `}<a parentName="p" {...{
        "href": "https://us.posthog.com/settings/project-replay#replay"
      }}>{`project settings`}</a>{` `}<strong parentName="p">{`or`}</strong>{` client-side by setting `}<inlineCode parentName="p">{`enable_recording_console_log: true`}</inlineCode>{` in our `}<a parentName="p" {...{
        "href": "/docs/libraries/js/config"
      }}>{`JavaScript Web SDK config`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js-web"
      }}>{`posthog.init('<ph_project_api_key>', {
  api_host: '<ph_client_api_host>',
  defaults: '<ph_posthog_js_defaults>',
    enable_recording_console_log: true, // TIP: This is only needed if you aren't configuring session replay using the project settings toggle.
    // ... other options
})
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Important:`}</strong>{` Individual console logs are truncated at 2000 characters. The rest of the log is not sent to PostHog. When truncating a log message we add `}<inlineCode parentName="p">{`...[Truncated]`}</inlineCode>{` to the message.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      